import React from "react";
import PropTypes from "prop-types";

const ContextualHelpBanner = ({ children, className = "" }) => (
	<div
		className={`contextual-help-banner ${className}`.trim()}
		role="status"
	>
		<span className="contextual-help-banner__icon" aria-hidden>
			!
		</span>
		<span className="contextual-help-banner__text">{children}</span>
	</div>
);

ContextualHelpBanner.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};

export default ContextualHelpBanner;
